import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { bool, func, string, number, arrayOf, object } from 'prop-types';
import { find, get } from 'lodash';
import { useIntl } from 'react-intl';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import HelpIcon from '@material-ui/icons/Help';
import Chip from '@material-ui/core/Chip';

import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import { Tooltip, withStyles } from '@material-ui/core';

import CertificateIcon from '../../icons/certificate.svg';
import ExternalAuthIcon from '../../icons/externalauth.svg';
import KeyIcon from '../../icons/key.svg';
import {
  TablePagination,
} from '../../../../components';
import { getI18n, getI18nFormattedMessage } from '../../../../utils/intl';

import {
  fetchKeyStores,
  fetchKeyStoresByApiKey,
  deployApiKeyToKeyStore,
  redeployApiKeyToKeyStore,
  undeployApiKeyFromKeyStore,
} from '../../../../actions/application';
import {
  fetchAuthProvidersList,
} from '../../../../actions/authProviders';
import {
  getAuthProvidersList,
} from '../../../../reducers/authProviders';
import {
  getKeyStores,
  getKeyStoresByApiKey,
  getKeyStoreErrors,
} from '../../../../reducers/application';
import {
  fetchDeploymentRefreshTime,
} from '../../../../actions/portalConfig';
import {
  getUserDetails,
  getDeploymentRefreshTime,
} from '../../../../reducers/portalConfig';
import {
  hasPublisherRole,
} from '../../../../utils';
import {
  getKeyStatus,
} from '../utils';
import { getTimeZoneAbbr } from '../../../../utils/datetime';
import DeploymentCard from './DeploymentCard';

import {
  AUTHENTICATION_LABEL,
  KEY_NAME_LABEL,
  STATUS_LABEL,
  DAYS_TO_KEY_EXPIRY_LABEL,
  NO_RESULTS_TEXT,
} from '../labels';

import styles from './styles';
import {
  APPLICATION_STATUS_DELETE_PENDING_APPROVAL,
} from '../../../../constants';
import { Lock } from '@material-ui/icons';
import moment from 'moment';
import clsx from 'clsx';

export const getDeploymentList = (deployments = [], apiKeyKeyStores = []) => {
  const combinedList = [];
  deployments.map((deployment) => {
    const matchedDeployment = apiKeyKeyStores.find(apiKeyDeployment =>
      apiKeyDeployment.keyStoreUuid === deployment.uuid);
    if (matchedDeployment) {
      combinedList.push(Object.assign({}, matchedDeployment, deployment));
    } else {
      combinedList.push(Object.assign({}, deployment));
    }
    return true;
  });
  return combinedList;
};
export const renderDeploymentTypeHelpText = (classes) => (
  <p className={classes.helpTextContainer}>
    <span className={classes.boldText}>{getI18nFormattedMessage('label.application.key.deployment.tooltip.title')}</span><br />
    <span>{getI18nFormattedMessage('label.application.key.deployment.tooltip.subtitle')}</span><br />
    <span>
      <span className={classes.boldText}>&#8226; {getI18nFormattedMessage('label.application.key.deployment.automatic.tooltip.title')}: </span>
      {getI18nFormattedMessage('label.application.key.deployment.automatic.tooltip.subtitle')}
    </span>
    <br />
    <span>
      <span className={classes.boldText}>&#8226; {getI18nFormattedMessage('label.application.key.deployment.on.demand.tooltip.title')}: </span>
      {getI18nFormattedMessage('label.application.key.deployment.on.demand.tooltip.subtitle')}
    </span>
  </p>
);
const SingleKeyView = (props) => {
  const {
    applicationUuid,
    apiKey,
    deploymentList = [],
    deploymentErrors,
    user,
    history,
    classes,
    isDeletePending,
    isEditDisabled,
    keyStatus,
  } = props;

const formatActionsColumnTitle = () => (<span className={classes.actionsColumnTitle}>
  {getI18nFormattedMessage('label.application.details.keys.deployments.table.columns.deployment.actions')}
  {isDeletePending &&
      <Tooltip
        title={getI18nFormattedMessage('label.application.details.deployments.locked.tooltip')}
        arrow placement="right">
        <Lock className={classes.lockIcon}/>
      </Tooltip>
    }
</span>);
const appKeyDeploymentColumns = [{
    id: 'keyStoreName',
    label: getI18nFormattedMessage('label.key.store'),
    minWidth: 200,
    value: (item) => item.name,
  }, {
    id: 'keyStoreType',
    label: getI18nFormattedMessage('label.application.details.keys.deployments.table.columns.key.store.type'),
    minWidth: 300,
    value: (item) => item.name,
  }, {
    id: 'deploymentType',
    label: getI18nFormattedMessage('label.application.details.keys.deployments.table.columns.deployment.type'),
    minWidth: 300,
    helpText: true,
    value: (item) => item.name,
  }, {
    id: 'deploymentStatus',
    label: getI18nFormattedMessage('label.application.details.keys.deployments.table.columns.deployment.status'),
    minWidth: 100,
    value: (item) => item.name,
  }, {
    id: 'lastTimeDeployed',
    label: getI18nFormattedMessage('label.api.date.last.deployed', { zone: getTimeZoneAbbr() }),
    minWidth: 50,
  }, {
    id: 'deploymentActions',
    label: formatActionsColumnTitle(),
    minWidth: 100,
    value: (item) => item.name,
  }];
  return (
    <Fragment>
      <div className={classes.innerTable}>
      {deploymentList.length > 0 ?
        <Table>
          <TableHead className={classes.innerTableHead}>
            {appKeyDeploymentColumns.map(column =>
              <TableCell key={column.id}>
                {column.label}
                {column.helpText &&
                  <Tooltip title={renderDeploymentTypeHelpText(classes)} arrow placement="right">
                    <HelpIcon className={classes.helpIcon} />
                  </Tooltip>}
              </TableCell>)
            }
          </TableHead>
          <TableBody>
          {deploymentList.map((obj, idx) => (
            <DeploymentCard
              key={idx}
              index={idx}
              details={{
                applicationUuid,
                apiKey,
                uuid: obj.uuid,
                name: obj.name,
                keyStoreType: obj.keyStoreType,
                type: obj.deploymentType,
                status: obj.status,
                statusMessage: obj.message,
                lastTimeDeployed: obj.lastTimeDeployed,
              }}
              errorObj={
                deploymentErrors.find(err =>
                  (err.keyStoreUuid === obj.uuid && err.apiKey === apiKey))
              }
              refreshTime={Number.parseFloat(props.refreshTime)}
              deployApiKey={props.deployApiKeyToKeyStore}
              redeployApiKey={props.redeployApiKeyToKeyStore}
              undeployApiKey={props.undeployApiKeyFromKeyStore}
              checkStatus={props.fetchKeyStoresByApiKey}
              user={user}
              history={history}
              classes={classes}
              isDeletePending={isDeletePending}
              isEditDisabled={isEditDisabled}
              keyStatus={keyStatus}
            />))}
          </TableBody>
        </Table>
        :
        <span className={classes.noResultSpan}>{NO_RESULTS_TEXT}</span>
        }
      </div>
    </Fragment>
  );
};

SingleKeyView.propTypes = {
  applicationUuid: string,
  apiKey: string,
  deploymentList: arrayOf(object),
  deploymentErrors: arrayOf(object),
  fetchProxiesByApiKey: func,
  user: object,
  history: object,
  classes: object,
  refreshTime: string,
  deployApiKeyToKeyStore: func,
  redeployApiKeyToKeyStore: func,
  undeployApiKeyFromKeyStore: func,
  fetchKeyStoresByApiKey: func,
  fetchProxies: func,
  fetchDeploymentRefreshTime: func,
  isDeletePending: bool,
  isEditDisabled: bool,
  keyStatus: string,
};

const SingleRow = (props) => {
  const {
    authProviders,
    idx,
    row,
    deployments,
    classes,
    isDeletePending,
    expandIndex,
    setExpandIndex,
    isEditDisabled,
    earliestExpiryCertTs,
    startReportingDays,
    urgentReportingDays,
  } = props;
  const getExpiryStatus = () => {
    const authMethod = get(row, 'authMethod');
    const secretExpiryTsInMS = authMethod === 'SECRET' ? get(row, 'secretExpiryTs') : earliestExpiryCertTs;
    const status = get(row, 'status');
    const keyId = get(row, 'apiKey');
    if (!secretExpiryTsInMS || (authMethod === 'NONE')) {
      return (<span />)
    }
    // const secretExpiryTsInMS = 1682009761000;
    const expiryTime = moment(secretExpiryTsInMS);
    const currentTime = moment();
    const days = expiryTime.diff(currentTime, 'days');
    let className = classes.normalKey;
    let label = '';
    // string to represent status, which is used by automation
    let expiryStatus;
    if (status === 'EXPIRED' || status === 'DISABLED') {
      label = '';
      className = '';
      expiryStatus = 'none';
    } else {
      label = days;
      if (days <= urgentReportingDays) {
        className = classes.urgentReportingKey;
        expiryStatus = 'urgentReporting';
        if (days < 0) {
          label = 0;
        }
      } else if (days > startReportingDays) {
        className = classes.normalKey;
        expiryStatus = 'normal';
      } else {
        className = classes.startReportingKey;
        expiryStatus = 'startReporting';
      }
    }

    return (
    <span
      data-apim-test={`key-${keyId}-expiry-status-${expiryStatus}`}
      className={clsx(classes.status, className)}
    >
      {label}
    </span>);
  };
  const getAuthenticationInfo = () => {
    const authProvider = find(authProviders, item => item.uuid === row.authProviderUuid);
    return authProvider && authProvider.name;
  };
  const getAuthMethodIcon = (authMethod) => {
    if (authMethod === 'SECRET') {
      return KeyIcon;
    } else if (authMethod === 'CERTIFICATE') {
      return CertificateIcon;
    }
    return ExternalAuthIcon;
  };

  return (
    <Fragment>
      <TableRow onClick={() => setExpandIndex(expandIndex === idx ? -1 : idx)}>
      <TableCell component="th" scope="row" className={classes.flexBlock}>
          <img src={getAuthMethodIcon(get(row, 'authMethod'))}
            className={classes.certOrKeyIcon}
          />
          <span className={classes.keyListKeyName}>
            {row.name}
          </span>
          {get(row, 'defaultKey') &&
            <Chip
              className={classes.defaultChip}
              size="small"
              label={'Default'}
            />
          }
        </TableCell>
        <TableCell component="th" scope="row">
          {getAuthenticationInfo()}
        </TableCell>
        <TableCell component="th" scope="row">
          {getKeyStatus(get(row, 'status'), classes)}
        </TableCell>
        <TableCell component="th" scope="row">
          {getExpiryStatus()}
        </TableCell>
        <TableCell component="th" scope="row">
          <IconButton
            className={classes.expandCollapseButton}
            size="small"
            onClick={() => setExpandIndex(expandIndex === idx ? -1 : idx)}
          >
            {expandIndex === idx ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <Collapse in={expandIndex === idx} timeout="auto" unmountOnExit>
            <SingleKeyView
              {...props}
              apiKey={get(row, 'apiKey')}
              deploymentList={getDeploymentList(deployments, get(row, 'proxies', []))}
              isDeletePending={isDeletePending}
              isEditDisabled={isEditDisabled}
              keyStatus={get(row, 'status')}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

SingleRow.propTypes = {
  applicationUuid: string,
  authProviders: arrayOf(object),
  idx: number,
  intl: object,
  row: number,
  deployments: arrayOf(object),
  classes: object,
  isDeletePending: bool,
  expandIndex: number,
  setExpandIndex: func,
  isEditDisabled: bool,
  earliestExpiryCertTs: number,
  startReportingDays: number,
  urgentReportingDays: number,
};

const GRID_ROWS_PER_PAGE_OPTIONS = [10, 20];
const GRID_ROWS_PER_PAGE_DEFAULT_OPTION = 10;

export const DeploymentsRaw = (props) => {
  const {
    applicationUuid,
    applicationDetails,
    fetchApplicationKeys,
    fetchAuthProvidersList,
    appKeys = [],
    appKeysTotalPages,
    appKeysTotalElements,
    authProviders,
    isMultiKeySupport,
    deployments = [],
    apiKeyKeyStores = [],
    deploymentErrors = [],
    user,
    history,
    classes,
    isEditDisabled,
    apiKeySettings,
    certificateList,
    earliestExpiryCertTs,
  } = props;
  const intl = getI18n(useIntl());
  const [isMultiKeyView, setIsMultiKeyView] = useState(false);
  const [deploymentList, setDeploymentList] = useState([]);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
  const [expandIndex, setExpandIndex] = useState(0);
  const isApiKeyExpiryEnabled = get(apiKeySettings, 'enabled', false);
  const startReportingDays = get(apiKeySettings, 'startReportingBeforeDays', 90);
  const urgentReportingDays = get(apiKeySettings, 'reportAsUrgentBeforeDays', 60);
  const onChangePage = (newPage) => {
    if (page === newPage) { return; }
    setPage(newPage);
    fetchApplicationKeys(applicationUuid, newPage, rowsPerPage);
  };
  const onChangePreviousPage = () => { onChangePage(page - 1); };
  const onChangeNextPage = () => { onChangePage(page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchApplicationKeys(applicationUuid, 0, newRowsPerPage);
  };

  useEffect(() => {
    fetchAuthProvidersList();
  }, [fetchAuthProvidersList])

  useEffect(() => {
    if (isMultiKeySupport && hasPublisherRole(user)) { // Multikey View
      props.fetchKeyStores();
      props.fetchDeploymentRefreshTime();
      appKeys.map(obj => {
        props.fetchKeyStoresByApiKey(obj.apiKey);
        return true;
      });
    } else {
      const apiKey = get(applicationDetails, 'apiKey');
      if (apiKey) {
        if (hasPublisherRole(user)) {
          props.fetchKeyStores();
          props.fetchDeploymentRefreshTime();
          props.fetchKeyStoresByApiKey(apiKey);
        }
      }
    }
  }, [applicationDetails, isMultiKeySupport]);

  useEffect(() => {
    if (appKeys.length > 0) {
      const tempArr = [];
      appKeys.map((obj) => {
        tempArr.push(Object.assign({},
          apiKeyKeyStores.find((o) => o.key === obj.apiKey),
          obj),
        );
        return true;
      });
      setRows(tempArr);
      setIsMultiKeyView(true);
    } else {
      const apiKey = get(applicationDetails, 'apiKey');
      const keyObject = apiKeyKeyStores.find(o => o.key === apiKey);
      setDeploymentList(getDeploymentList(deployments, get(keyObject, 'keyStores', [])));
      setIsMultiKeyView(false);
    }
  }, [apiKeyKeyStores, appKeys, apiKeyKeyStores.length, deployments.length]);

  return (
    <div
      className={classes.appDeploymentsContainer}
      id="app-deployments-container" data-layer7-test="app-deployments-container"
    >
      {isMultiKeyView ?
        <Fragment>
          <TableContainer className={classes.tableContainer}>
            <Table aria-label="collapsible table">
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell>{KEY_NAME_LABEL}</TableCell>
                  <TableCell align={'center'}>{AUTHENTICATION_LABEL}</TableCell>
                  <TableCell align={'center'}>{STATUS_LABEL}</TableCell>
                  <TableCell align={'center'}>{DAYS_TO_KEY_EXPIRY_LABEL}</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, idx) =>
                  <SingleRow
                    authProviders={authProviders}
                    key={idx}
                    {...props}
                    row={row}
                    idx={idx}
                    intl={intl}
                    history={history}
                    isDeletePending=
                    {applicationDetails
                      && applicationDetails.status === APPLICATION_STATUS_DELETE_PENDING_APPROVAL}
                    expandIndex={expandIndex}
                    setExpandIndex={setExpandIndex}
                    isEditDisabled={isEditDisabled}
                    isApiKeyExpiryEnabled={isApiKeyExpiryEnabled}
                    startReportingDays={startReportingDays}
                    urgentReportingDays={urgentReportingDays}
                    certificateList={certificateList}
                    earliestExpiryCertTs={earliestExpiryCertTs}
                  />)}
              </TableBody>
            </Table>
          </TableContainer>
          <div className={classes.paginationContainer}>
            <TablePagination
              id="app-deployments-keys-pagination"
              data-apim-test="app-deployments-keys-pagination"
              page={page}
              count={appKeysTotalElements}
              pageCount={appKeysTotalPages}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={GRID_ROWS_PER_PAGE_OPTIONS}
              onChangeRowsPerPage={onChangeRowsPerPage}
              onChangePage={onChangePage}
              onChangePreviousPage={onChangePreviousPage}
              onChangeNextPage={onChangeNextPage}
              labelRowsPerPage={intl.getI18nMessage('label.pagination.rows.per.page')}
            />
          </div>
        </Fragment> :
        <SingleKeyView
          {...props}
          applicationUuid={applicationUuid}
          apiKey={get(applicationDetails, 'apiKey')}
          deploymentErrors={deploymentErrors}
          deploymentList={deploymentList}
          history={history}
        />
      }
    </div>
  );
};

const mapStateToProps = state => ({
  authProviders: getAuthProvidersList(state),
  user: getUserDetails(state),
  deployments: getKeyStores(state),
  apiKeyKeyStores: getKeyStoresByApiKey(state),
  deploymentErrors: getKeyStoreErrors(state),
  refreshTime: getDeploymentRefreshTime(state),
});

const mapDispatchToProps = {
  fetchAuthProvidersList,
  fetchKeyStores,
  fetchKeyStoresByApiKey,
  fetchDeploymentRefreshTime,
  deployApiKeyToKeyStore,
  redeployApiKeyToKeyStore,
  undeployApiKeyFromKeyStore,
};

DeploymentsRaw.propTypes = {
  applicationUuid: string,
  applicationDetails: object,
  authProviders: arrayOf(object),
  fetchApplicationKeys: func,
  appKeys: arrayOf(object),
  appKeysTotalPages: number,
  appKeysTotalElements: number,
  isMultiKeySupport: bool,
  deployments: arrayOf(object),
  apiKeyKeyStores: arrayOf(object),
  deploymentErrors: arrayOf(object),
  fetchAuthProvidersList: func,
  history: object,
  user: object,
  classes: object,
  fetchKeyStores: func,
  fetchDeploymentRefreshTime: func,
  isEditDisabled: bool,
  fetchKeyStoresByApiKey: func,
  apiKeySettings: object,
  certificateList: arrayOf(object),
  earliestExpiryCertTs: number,
};
DeploymentsRaw.displayName = 'Deployments';

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(DeploymentsRaw);
